import { RoleType, RolesAction, RolesActionTypes } from "store/types/roles";

const initialState: RoleType[] = [];

export const roles = (state = initialState, action: RolesActionTypes) => {
  switch (action.type) {
    case RolesAction.REPLACE_ROLES:
      return action.roles;
    case RolesAction.ADD_ROLE:
      return [...state, action.role];
    case RolesAction.UPDATE_ROLE:
      return state.map((r) => (r._id === action.role._id ? action.role : r));
    case RolesAction.DELETE_ROLE:
      return state.filter((r) => r._id !== action.roleId);
    default:
      return state;
  }
};
